
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserDefaultHomepageService } from '../../common/providers/user-default-homepage.service';
import { SessionItemRow, SessionItemsProvider } from '../../sessions/providers/sessionItems-provider';
import { ActivatedRoute, Router } from '@angular/router';
import { ExercicesProvider } from '../../exercices/providers/exercices-provider';
import { BreadcrumbProvider } from '../../breadcrumb/providers/breadcrumb-provider';
import { Subscription } from 'rxjs';
import { Exercice } from "../../common/models/exercice";
import { Organization } from "../../common/models/organization";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { ModuleContentComponent } from "../../common/components/module-content/module-content";
import {
  SessionExerciceDurationComponent
} from "../../sessions/components/session-exercice-duration/session-exercice-duration";
import {
  SessionExerciceRepeatComponent
} from "../../sessions/components/session-exercice-repeat/session-exercice-repeat";
import { NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'app-mobile-exercise-show-component',
  providers: [UserDefaultHomepageService],
  styleUrls: ['./exercise-show.component.scss'],
  standalone: true,
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    ModuleContentComponent,
    SessionExerciceDurationComponent,
    SessionExerciceRepeatComponent,
    NgIf,
    TranslateModule,
    FlexLayoutModule
  ],
  templateUrl: './exercise-show.component.html'
})
export class MobileExerciseShowComponent implements OnInit, OnDestroy {

    public readonly EXERCISE_TYPE_REPEAT = Exercice.TYPE_REPEAT;
    public readonly EXERCISE_TYPE_DURATION = Exercice.TYPE_DURATION;

    public pageTitle = '';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public exercise: Exercice = {} as Exercice;
    public totalTime = 0;
    public data: SessionItemRow = {} as SessionItemRow;

    public sessionId: number | undefined;
    private subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private exerciseProvider: ExercicesProvider,
        private sessionItemsProvider: SessionItemsProvider,
        private _sessionItemsProvider: SessionItemsProvider,
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data:any) => {// { organization: Organization; exercise: Exercice }
                this.organization = data.organization;
                this.exercise = data.exercise;

                if (null === this.exercise) {
                    this.isLoading = false;

                    return;
                }

                this.subscriptions.push(
                    this.route.queryParams.subscribe((params) => {
                        this.sessionId = +params["session"];

                        if (this.sessionId && !Number.isNaN(this.sessionId)) {
                            this._sessionItemsProvider.listSessionItemRows(this.organization, this.sessionId).subscribe((rows) => {
                                for (const innerElement of rows[0].innerElements) {
                                    if (innerElement.data && innerElement.data.exercice && innerElement.data.exercice.exercice && this.exercise && innerElement.data.exercice.exercice.id === this.exercise.id) {
                                        this.data = innerElement;
                                        this.isLoading = false;
                                        return;
                                    }
                                }
                            });
                        }

                        this.exerciseProvider.getExerciceRow(this.organization, this.exercise.id!).subscribe((row) => {
                            this.data = this.sessionItemsProvider.getEmptyItemExercice(row);
                            this.totalTime = this.exerciseProvider.getTotalTime(row);

                            this.isLoading = false;
                        });
                    })
                );
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
